import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=33a11635&scoped=true"
import script from "./product-list.vue?vue&type=script&lang=js"
export * from "./product-list.vue?vue&type=script&lang=js"
import style0 from "./product-list.vue?vue&type=style&index=0&id=33a11635&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a11635",
  null
  
)

export default component.exports